<div *subscriptionPlan="planType.BASIC" class="flex flex-col">
  <h4 class="m-0 text-lg font-bold text-default">{{ 'Absence' | translate }}</h4>
  <div class="flex items-center justify-between py-4">
    <sb-button-group>
      <button
        sb-button
        [color]="absenceFilter === absenceFilterOptions.PENDING_OR_OPEN_ENDED ? 'selected' : 'secondary'"
        (click)="absenceFilter = absenceFilterOptions.PENDING_OR_OPEN_ENDED"
      >
        <div class="flex items-center gap-2">
          {{ 'Requests' | translate }}
          @if (pendingOrOpenEndedCount > 0) {
            <sb-notification-badge [count]="pendingOrOpenEndedCount" [color]="'brandInverted'" />
          }
        </div>
      </button>
      <button
        sb-button
        [color]="absenceFilter === absenceFilterOptions.FUTURE ? 'selected' : 'secondary'"
        (click)="absenceFilter = absenceFilterOptions.FUTURE"
      >
        <div class="flex items-center gap-2">
          {{ 'Reviewed' | translate }}
          @if (reviewedFutureAbsences.length > 0) {
            <sb-notification-badge [count]="reviewedFutureAbsences.length" [color]="'brandInverted'" />
          }
        </div>
      </button>
      <button
        sb-button
        [color]="absenceFilter === absenceFilterOptions.PAST ? 'selected' : 'secondary'"
        (click)="absenceFilter = absenceFilterOptions.PAST"
      >
        {{ 'Past' | translate }}
      </button>
    </sb-button-group>
    @if (canRequestAbsence()) {
      <a
        sb-button
        [color]="'primary'"
        [routerLink]="[
          '',
          { outlets: { modal: ['add-absence', { employee: employee()?.id, selectedYear: selectedYear }] } },
        ]"
      >
        <sb-icon name="plus" />
        {{ 'Add absence' | translate }}
      </a>
    }
  </div>
  @if (loadingAbsences) {
    <sb-loading-state class="h-40" />
  } @else {
    <ng-container *ngTemplateOutlet="loaded"></ng-container>
  }
</div>

<ng-template #loaded>
  @switch (absenceFilter) {
    @case (absenceFilterOptions.PENDING_OR_OPEN_ENDED) {
      @if (pendingOrOpenEndedCount === 0) {
        <sb-empty-state
          class="h-40 rounded-md border border-solid border-default"
          [icon]="'calendar-month'"
          [description]="'No requests' | translate"
        >
          <button sb-button [color]="'primary'" (click)="absenceFilter = absenceFilterOptions.FUTURE">
            {{ 'Check reviewed absences' | translate }}
          </button>
        </sb-empty-state>
      }
      <div class="flex flex-col gap-4 empty:hidden">
        @if (reviewedOpenEndedAbsences.length > 0) {
          <span class="font-semibold text-default">{{ 'End date unknown' | translate }}</span>
          <absence-list [absences]="reviewedOpenEndedAbsences" />
        }
        @if (pendingAbsences.length > 0) {
          <span class="font-semibold text-default">{{ 'Pending' | translate }}</span>
          <absence-list [absences]="pendingAbsences" />
        }
      </div>
    }
    @case (absenceFilterOptions.FUTURE) {
      @if (reviewedFutureAbsences.length === 0) {
        <sb-empty-state
          class="h-40 rounded-md border border-solid border-default"
          [icon]="'calendar-month'"
          [description]="'No upcoming absences' | translate"
        />
      } @else {
        <absence-list [absences]="reviewedFutureAbsences" />
      }
    }
    @case (absenceFilterOptions.PAST) {
      @if (reviewedPastAbsences.length === 0) {
        <sb-empty-state
          class="h-40 rounded-md border border-solid border-default"
          [icon]="'calendar-month'"
          [description]="'No past absences' | translate"
        />
      } @else {
        <absence-list [absences]="reviewedPastAbsences" />
      }
    }
  }
</ng-template>
